export function NewsletterPodium({ tournaments, labels }) {
  if (!tournaments?.length) return null;
  return (
    <section className="pingflo-section">
      <h2>{labels.title}</h2>
      {tournaments.map((event) => (
        <article key={`${event.event_date}-${event.name}`} className="pingflo-event">
          <header>
            <h3>{event.name}</h3>
            <p>{labels.date(event.event_date)}</p>
          </header>
          {event.finalists?.length ? (
            <ol className="pingflo-podium">
              {event.finalists.map((finalist) => (
                <li key={`${finalist.place}-${finalist.name}-${finalist.category}`}>
                  <b>{finalist.place}</b>
                  <span>{finalist.name}</span>
                  {finalist.category ? <small>{finalist.category}</small> : null}
                </li>
              ))}
            </ol>
          ) : null}
          {event.results?.length ? (
            <ul className="pingflo-results">
              {event.results.map((row, index) => (
                <li key={`${row.name}-${row.opponent}-${index}`}>
                  <span className="pingflo-name">{row.name}</span>
                  <span className="pingflo-quiet">{labels.vs}</span>
                  <span>{row.opponent}</span>
                  <span className={`pingflo-metric${row.outcome === "win" ? " is-pb" : ""}`}>
                    {row.sets_for != null && row.sets_against != null
                      ? `${row.sets_for}–${row.sets_against}`
                      : labels.outcome(row.outcome)}
                  </span>
                </li>
              ))}
            </ul>
          ) : null}
        </article>
      ))}
    </section>
  );
}
